import React, { useEffect } from "react";
import { Fade, Zoom } from "react-reveal";
import SubHeader from "../components/SubHeader";
import "./WhyChoose.css";

export default function WhyChoose() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const reason = (title, description) => (
    <div className="reason">
      <div className="icon-div"></div>
      <div className="detail">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
  return (
    <>
      <section className="why-choose" id="why-us">
        <div className="container">
          <Fade right>
            <div className="context">
              <div className="content">
                <SubHeader
                  title={"WHY CHOOSE US"}
                  subheader="We are value-based."
                />
                <p>
                  Not only are we committed to providing exceptional mental
                  health care but also we pride ourselves in operating in a
                  strong foundation of values that prioritize adding value to
                  those who interact with us. Here are some of the reasons as to
                  why you should journey with us:
                </p>
                <div className="reasons">
                  {reason(
                    "Personalized approach",
                    "We understand that mental health is deeply personal hence tailoring our services to meet your unique needs perferences and goals."
                  )}
                  {reason(
                    "Trusted and certified professionals",
                    "Our team consist of highly qualified and certified therapist who bring a wealth of experties and compation to every sessional."
                  )}
                  {reason(
                    "Affordability without compromise",
                    "We believe that everyone deserves access to quality mental health care, Regardless of financial constraints."
                  )}
                  {reason(
                    "Convenience",
                    "Get convenient virtual sessions, hustle free and at your own comfort. You decide!"
                  )}
                </div>
              </div>
            </div>
          </Fade>
          <Zoom>
            <div className="image"></div>
          </Zoom>
        </div>
      </section>
      <hr />
    </>
  );
}
